import classNames from 'clsx';
import React from 'react';
import type { HeaderGroup, UseTableInstanceProps } from 'react-table';

import ToggleArrow from '@swf/core/assets/icons/arrow.svg';
import type { TableColumnInstance, Tournament } from '@swf/poker';

import sharedStyles from '../shared.scss';

import styles from './TableHead.scss';

type Props = Pick<UseTableInstanceProps<Tournament>, 'headerGroups'> & {
  handleColumnClick: (column: TableColumnInstance) => void;
};

const TableHead: React.FC<Props> = ({ headerGroups, handleColumnClick }) => (
  <div className={styles.container}>
    {headerGroups.map((headerGroup) => {
      const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();

      const onColumnClicked = (column: TableColumnInstance) => handleColumnClick(column);

      return (
        <div className={styles.row} key={key} {...headerGroupProps}>
          {headerGroup.headers.map((column: HeaderGroup<Tournament>) => {
            const { key, ...headerProps } = column.getHeaderProps(column.getSortByToggleProps());
            const tableColumn = column as unknown as TableColumnInstance;

            return (
              <div
                key={key}
                {...headerProps}
                className={classNames(
                  sharedStyles.cell,
                  {
                    [sharedStyles.cellExpand]: tableColumn.cellExpand,
                    [styles.sortedHead]: tableColumn.isSorted
                  },
                  styles.head
                )}
                onClick={() => onColumnClicked(tableColumn)}
                style={{
                  width: tableColumn.width,
                  cursor: 'pointer',
                  textAlign: tableColumn.align,
                  userSelect: 'none'
                }}
              >
                {tableColumn.render('Header')}
                {tableColumn.isSorted && (
                  <ToggleArrow
                    className={classNames(styles.arrow, {
                      [styles.upwardsArrow]: tableColumn.isSortedDesc
                    })}
                  />
                )}
              </div>
            );
          })}
        </div>
      );
    })}
  </div>
);

export default TableHead;
